import Layout from "HorizontalMenu/Menu";
import Navbar from "HorizontalMenu/Navbar";
import React from "react";
import { Container } from "reactstrap";
// import { useDispatch, useSelector } from 'react-redux';
// import { RootState } from 'index';
// import { setVesselID } from 'Store/Generic/ReportingSlice';
// import Select from 'react-select';
// import UkMrvPartial from './partials/UkMrvPartial';
import underConstruction from "../Media/underConstruction.jpg";

const UkMrv = () => {
    // const dispatch = useDispatch();
    // const { Vessels, VesselID } = useSelector((state: RootState) => state.Reporting);

    // const handleVesselSelectionChanges = (e: any) => {
    //     dispatch(setVesselID(e.id));
    // }

    return (
        <React.Fragment>
            <Layout children={Navbar} />
            <Container fluid>
                {/* <Row>
                    <Col lg={4}>
                        <Label className='mb-0'>Select vessel</Label>
                        <Select
                            options={Vessels}
                            getOptionLabel={option => option.vessel_name}
                            getOptionValue={option => option.id}
                            onChange={(e: any) => handleVesselSelectionChanges(e)}
                        />
                    </Col>
                </Row>
                {VesselID > 0 &&
                    <UkMrvPartial vesselId={VesselID} />
                } */}
                <img
                    src={underConstruction}
                    alt=""
                    height="800"
                    className="pos-center"
                />
            </Container>
        </React.Fragment>
    );
};

export default UkMrv;
